import React, { useEffect, useState } from 'react';
import dropdown from '../../assets/dropdown.svg';
import SimpleBarReact from 'simplebar-react';
import WarningDialogue from '../WarningDialogue';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import Popup from 'reactjs-popup';
import { messages } from '../../messages';

export default function CustomSelect(props) {
  const unique = 'custom-select-';
  const [optionOpen, setOptionOpen] = useState(false);
  const [data, setData] = useState([]);
  const [label, setLabel] = useState('Label');
  const [placeholder, setPlaceholder] = useState('Select...');
  const [type, setType] = useState(null);
  const [selector, setSelector] = useState('title');
  const [selectedData, setSelectedData] = useState(null);
  const [key, setKey] = useState(unique);
  const [dialog, setDialog] = useState({
    open: false,
    data: null,
    description: '',
  });
  const [eventReasonErr, setEventReasonErr] = useState('');
  const [eventReason, setEventReason] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [popupData, setPopupData] = useState({
    open: false,
    data: '',
  });
  const [isDropUp, setIsDropUp] = useState(false);

  useEffect(() => {
    setData(props.data || []);
    setLabel(props.label || '');
    setPlaceholder(props.placeholder || 'Select...');
    setType(props.type || null);
    setSelector(props.selector || 'title');
    setDisabled(props.disabled || false);
    if (props.uniqueKey) {
      setKey(props.uniqueKey || unique);
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setData(props.data || []);
  }, [props.data]);

  useEffect(() => {
    setPlaceholder(props.placeholder);
  }, [props.placeholder]);

  useEffect(() => {
    if (placeholder !== props.placeholder) {
      if (type) {
        props.onSelect(selectedData, type);
      } else {
        props.onSelect(selectedData);
      }
    }
    setOptionOpen(false);
    //eslint-disable-next-line
  }, [placeholder]);

  const closePopUp = () => {
    setDialog({
      open: false,
      description: '',
      data: null,
    });
  }

  const handleValidation = () => {
    let formIsValid = true;

    if (!eventReason) {
      formIsValid = false;
      setEventReasonErr(messages.emptyField);
    }
    return formIsValid;
  }
  const handleSubmit = (e) => {
    setFormSubmitted(true);
    if (handleValidation()) {
      setSelectedData(e.data);
      setPlaceholder(e.data[selector]);
      setPopupData((prev) => ({
        ...prev,
        open: false
      }))
    }
  }

  const calculateHeight = (e) => {
    const dropdown = e.target;
    const bottom = e.clientY;
    const screenHeight = window.innerHeight;
    setIsDropUp((screenHeight - bottom < 250) ? true : false);
  }

  return (
    <>
      {
        optionOpen && !disabled &&
        <div onClick={() => setOptionOpen(o => !o)}
          style={
            {
              position: 'fixed',
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 1,
            }
          }>
        </div>
      }
      <div className={`${props.className ? props.className + ' ' : ''}input-field`}>
        {label && <label>{label}{props.required ? <sup>*</sup> : ''}</label>}
        <div className="dropdown-blk2">
          <div id='drop_down' className="dropdown-header" onClick={(e) => { if (!props?.requestRunning) { setOptionOpen(o => !o); calculateHeight(e) } }}>
            <span>{placeholder}</span>
            <div className="arrow-blk">
              <img src={dropdown} alt="dropdown" />
            </div>
          </div>

          {optionOpen && !disabled && <ul className={`${optionOpen ? 'active' : ''} ${isDropUp ? 'open-upwards' : ''} dropdown-menu${!data.length ? " noRecord" : ""}`}>
            <SimpleBarReact className={`custom-select ${props.noScroll ? 'no-max-height' : ''}`} style={{
              maxHeight: 200,
            }}>
              {
                data.length
                  ?
                  (
                    data.map((d, idx) => {
                      return (
                        <li key={key + idx} onClick={() => {
                          if (props.shoWarning) {
                            return setDialog({
                              open: true,
                              data: d,
                              description: d.title,
                            });
                          }
                          if (props.showConfirmation) {
                            if (d.id === 'rejected') {
                              return setPopupData({
                                open: true,
                                data: d
                              })
                            } else {
                              return setDialog({
                                open: true,
                                data: d,
                                description: d.title,
                              });
                            }
                          }
                          setSelectedData(d);
                          setPlaceholder(d[selector]);
                        }}>
                          {d[selector]}
                        </li>
                      );
                    })
                  )
                  :
                  (
                    <li className="noRecord" onClick={() => setOptionOpen(false)}>
                      No data.
                    </li>
                  )
              }
            </SimpleBarReact>
          </ul>}
        </div>
      </div>
      {
        (props.shoWarning || props.showConfirmation) &&
        <WarningDialogue
          isOpen={dialog.open}
          header={'Warning'}
          description={`Are you sure, you want to change ${props?.uniqueKey === 'weeks-key-matchup' ? 'week' : 'status'} to ${dialog.description}?`}
          icon={faExclamationTriangle}
          data={dialog.data}
          type={props?.uniqueKey === 'weeks-key-matchup' && props?.showSmsPopup ? 'week-moved-reschedule' : ''}
          action={(data, flag) => {
            if (flag !== undefined) {
              data.flag = flag;
            }
            setSelectedData(data);
            setPlaceholder(data[selector]);
            closePopUp();
          }}
          onClose={closePopUp}
        />
      }
      {props.showConfirmation && <Popup className='reason-popup' open={popupData.open} closeOnDocumentClick={false}>
        <span className="close" onClick={() => setPopupData((prev) => ({ ...prev, open: false }))}>&times;</span>
        <div className="cs-col-12">
          <div className="mul-input-field">
            <label htmlFor="">Reason <sup>*</sup></label>
            <textarea onChange={(e) => { setEventReason(e.target.value); props.leadRejectReason(e.target.value) }} name="reason" id="eventDetails"></textarea>
            <span className="error">{formSubmitted && eventReasonErr}</span>
          </div>
          <div className="btn-group btn-group-start">
            <button onClick={() => handleSubmit(popupData)} className="btn btn-pri">
              Confirm
            </button>
            <button onClick={() => { setPopupData((prev) => ({ ...prev, open: false })); setFormSubmitted(false) }} className="btn btn-sec"> Cancel </button>
          </div>
        </div>
      </Popup>}
    </>
  );
}